<template>
  <v-container fluid>
    <avs-card class="pb-4">
      <template v-slot:title>
        <v-toolbar
          class="mt-4 custom-toolbar"
          elevation="0"
        >
          <v-text-field
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            :label="$t('commons.search')"
            v-model="search"
          />
          <v-spacer></v-spacer>
          <template>
            <avs-button
              v-if="isUserAdminOnCompany"
              @click="inviteMembers"
              iconI="mdi-account-plus"
              color="accent"
              :spantext="$t('views.team.invite')"
            >
              <template v-slot:name>{{ $t("views.team.invite") }}</template>
            </avs-button>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:content>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="users"
          loading-text="Loading users..."
          no-data-text="No users found"
          disable-pagination
          hide-default-footer
          class="ma-10"
          :search="search"
        >
          <template v-slot:item.avatar="{ item }">
            <v-avatar
              class="my-4 secondary white--text"
              size="40"
            >
              <span>{{ getInitials(item) }}</span>
            </v-avatar>
          </template>
          <!-- <template v-slot:item.company_role="{ item }">
            <avs-role :role="item.company_role ? item.company_role : 'No role yet'" />
          </template> -->

          <template v-slot:item.company_role="{ item }">
            <avs-role
              v-if="!isRoleEditable(item)"
              :role="item.company_role ? item.company_role : $t('commons.not_role_yet')"
              disabled
            />
            <v-edit-dialog
              v-else
              large
              :return-value.sync="item.company_role"
              @save="editMemberRole(item)"
            >
              <avs-role :role="item.company_role" />

              <template v-slot:input>
                <div class="my-5 text-h6">{{ $t("views.team.select") }}</div>
                <v-select
                  v-model="item.company_role"
                  :items="roleItems"
                  chips
                  label="Roles"
                  outlined
                ></v-select>
              </template>
            </v-edit-dialog>
          </template>

          <template #item.date_joined="{ item }">
            {{ toDatetime(item.date_joined) }}
          </template>

          <!-- <template v-slot:item.is_active="{ item }">
            <avs-chip
              color="success"
              :disabled="item.is_active === 'Active' ? false : true"
              style="width: 88px"
            >
              {{ item.is_active }}
            </avs-chip>
          </template> -->
          <template #item.is_active="item">
            <v-switch
              v-model="item.item.is_active"
              inset
              color="success"
              :label="item.item.is_active ? 'Active' : 'Inactive'"
              @click="handleActivation(item.item)"
              :disabled="!isRoleEditable(item.item)"
            ></v-switch>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-end">
              <!-- <avs-editButton
                @click.stop="handleNonConformityEdit(item)"
                :spantext="
                  $t('actions.edit', {
                    entity: $tc('categories.nonconformity.name', 1).toLowerCase()
                  })
                "
              /> -->
              <avs-deleteButton
                @click="handleOpenDeleteDialog(item)"
                :spantext="
                  $t('actions.delete', {
                    entity: $tc('commons.user.name_singular', 1).toLowerCase()
                  })
                "
                :disabled="!isRoleEditable(item)"
              />
            </div>
          </template>
        </v-data-table>
        <avs-deleteDialog
          v-model="deleteDialogIsOpen"
          @cancel="handleCancel"
          @delete="handleDelete"
          resource="User"
        />
        <v-dialog
          v-model="dialogActivation"
          width="500"
          height="500"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5">
              Activation
              <v-spacer></v-spacer>
              <v-btn
                fab
                text
                @click="handleClose"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text
              v-if="!chosenUser.is_active"
              class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
              align="center"
              >Do you want to disable {{ fullName }}'s account ?
            </v-card-text>

            <v-card-text
              v-else
              class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
              align="center"
              >Do you want to reactivate {{ fullName }}'s account ?
            </v-card-text>

            <v-card-actions
              class="justify-center mt-10"
              v-if="!chosenUser.is_active"
            >
              <v-btn
                :style="{
                  paddingLeft: '80px',
                  paddingRight: '80px'
                }"
                text
                x-large
                class="mb-10 blue white--text"
                @click="confirmActivation"
              >
                Disable
              </v-btn>
            </v-card-actions>

            <v-card-actions
              class="justify-center mt-10"
              v-else
            >
              <v-btn
                :style="{
                  paddingLeft: '80px',
                  paddingRight: '80px'
                }"
                text
                x-large
                class="mb-10 blue white--text"
                @click="confirmActivation"
              >
                Reactivate
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </avs-card>
  </v-container>
</template>

<script>
import AdministrationServices from "@/services/AdministrationServices"
import CompanyService from "@/services/CompanyService"
import { toDatetime } from "@/utils/datetime"
import { PROJECT_MEMBER_ROLES } from "@/utils/consts"
import { initials } from "@/utils/string"

export default {
  name: "AdmininstrationUsers",
  data() {
    return {
      headers: [
        { text: "#", value: "avatar", width: "90" },
        { text: "First Name", align: "start", sortable: false, value: "first_name" },
        { text: "Last Name", align: "start", sortable: false, value: "last_name" },
        { text: "Email", align: "start", sortable: false, value: "email" },
        { text: "Role", align: "center", value: "company_role", sortable: false },
        { text: "Status", align: "center", value: "is_active", sortable: false },
        { text: "Join Date", align: "center", value: "date_joined", sortable: false },
        { text: "Actions", sortable: false, value: "actions", align: "right", width: 100 }
      ],
      dialogActivation: false,
      deleteDialogIsOpen: false,
      users: [],
      loading: false,
      search: "",
      companyId: null,
      companyName: null,
      selectedAccount: {},
      editable: false,
      chosenUser: {
        is_active: true
      },
      roleItems: PROJECT_MEMBER_ROLES
    }
  },
  computed: {
    fullName: {
      get: function () {
        return this.chosenUser.first_name + " " + this.chosenUser.last_name
      }
    },
    company() {
      return this.$store.state.app.company
    },
    isUserAdminOnCompany() {
      return this.company.company_role == "administrator"
    }
  },
  methods: {
    toDatetime,
    getInitials(item) {
      return initials(`${item.first_name} ${item.last_name}`)
    },
    isRoleEditable(item) {
      return item.company_role !== "administrator" && item.status != "inactive"
    },
    editMemberRole(item) {
      const invite = {
        email: item.email,
        privileges: {
          inspector: item.company_role === "inspector",
          operator: item.company_role === "operator"
        }
      }

      CompanyService.sendInvite(this, this.companyId, [invite])
    },
    handleOpenDialog(account) {
      this.activationDialog = true
      this.selectedAccount = account
    },
    confirmActivation() {
      const $ = this
      let data = {
        is_active: this.chosenUser.is_active
      }
      AdministrationServices.updateUserStatus(this, this.chosenUser.id, data).then(r => {
        this.loading = true
        AdministrationServices.getCompanyUsers($, this.companyId)
          .then(r => {
            this.users = r.results
          })
          .finally(() => {
            this.loading = false
            this.dialogActivation = false
          })
      })
    },
    fetchMembers() {
      this.loading = true
      AdministrationServices.getCompanyUsers(this, this.companyId)
        .then(response => {
          this.members = response
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * closing dialog activation, handling the is_active attribute of the company
     */
    handleClose() {
      this.dialogActivation = false
      this.chosenUser.is_active = !this.chosenUser.is_active
    },
    /**
     * handles the dialog activation with dialogActivation
     * @param user selected user that we want to change activation
     */
    handleActivation(user) {
      this.chosenUser = user
      this.dialogActivation = true
    },
    inviteMembers() {
      this.$router.push({ name: "CompanyInvitation" })
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete(item) {
      CompanyService.removeFromTeam(this, this.selectedItem.id).then(r => {
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.deleted", {
            entity: this.$tc("commons.user.name_singular", 1)
          }),
          color: "success"
        })
      })
      this.deleteDialogIsOpen = false
      this.fetchMembers()
    }
  },

  mounted() {
    this.loading = true
    this.companyId = this.$store.getters["app/getCompany"].pk
    this.companyName = this.$store.getters["app/getCompany"].name
    AdministrationServices.getCompanyUsers(this, this.companyId)
      .then(r => {
        this.users = r.results
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
